import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppBar, Tab, Tabs, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import SwipeableViews from "react-swipeable-views";
import { TabPanel } from "src/components/Common";
import { suscriberModules } from "src/services/admin/modules";
import useStyles from "src/views/viewAdministrador/dashboardAdmin/useStyles";
import { Settings } from "@material-ui/icons";
import ConfigEmpresa from "./ConfigEmpresa";
import ConfigParkey from "./ConfigParkey";

const ConfigIndex = () => {
  const classes = useStyles();
  const conjunto = useSelector((state) => state.complex.complex);
  const [modulos, setModulos] = useState({});
  const [value, setValue] = useState(0);

  useEffect(() => {
    const unsuscriber = suscriberModules({
      next: (querySnapshot) => {
        setModulos(querySnapshot.data());
      },
    });
    return unsuscriber;
  }, [conjunto.id]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (ind) => {
    setValue(ind);
  };

  return (
    <Page>
      <Typography variant="h1" align="center">
        <Settings fontSize="large" /> Configuración Parkey
      </Typography>
      <br />
      <AppBar position="static" className={classes.bar} color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ indicator: classes.indicator }}
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Parkey" className={classes.tab} />
          {modulos?.FacturacionElectronica && (
            <Tab label="Facturación" className={classes.tab} />
          )}
        </Tabs>
      </AppBar>
      <SwipeableViews index={value} onChangeIndex={handleChangeIndex}>
        <TabPanel value={value} index={0} sx={{ color: "white" }}>
          <ConfigParkey />
        </TabPanel>
        {modulos?.FacturacionElectronica && (
          <TabPanel value={value} index={1} sx={{ color: "white" }}>
            <ConfigEmpresa />
          </TabPanel>
        )}
      </SwipeableViews>
    </Page>
  );
};

export default ConfigIndex;
